import { billingToDeliveryDate } from "utils/subscription-date";
import { convertToISOString } from "helpers/format-date";

const obtainOrderInfo = (nextBillingDate, chargeOffsetDays, latest_sub_order) => {
	const next_delivery_date = billingToDeliveryDate(nextBillingDate, chargeOffsetDays);
	const created_at = latest_sub_order?.createdAt;
	const formatted_date = convertToISOString(latest_sub_order?.deliveryDate);

	if (!created_at || !formatted_date)
		return { date: next_delivery_date, isDispatched: false, show: false };

	const today = new Date();
	const latest_order_billing_date = new Date(created_at);
	const latest_order_delivery_date = new Date(formatted_date);

	if (today >= latest_order_billing_date && today <= latest_order_delivery_date) {
		return {
			isDispatched: true,
			isTrackable: true,
			date: latest_order_delivery_date,
			show: true
		};
	}

	return {
		isDispatched: new Date(nextBillingDate).toDateString() === today.toDateString() &&
			today.getHours() >= 9 && today.getHours() <= 11,
		isTrackable: false,
		date: next_delivery_date,
		show: new Date(nextBillingDate).toDateString() === today.toDateString() && today.getHours() > 11
	};
};

export default obtainOrderInfo;